/**
 * Created by ddxfc on 2017/8/1.
 */
/*
 * 注入配置向相关的变量
 */

export default function (injection, Vue) {
    const config = {
        errorCode: {
            ACCESS_TOKEN_EMPTY: 40000,
            ACCESS_TOKEN_EXPIRED: 40001,
            PERMISSION_DENIED: 50001,
            USER_NOT_FOUND: 50002,
            USER_NOT_SITE_USER: 50003,
            USER_EMAIL_USED: 50004,
            USER_IS_SITE_USER: 50005,
            CANNOT_DELETE_POST: 10001
        },
        errorText: {
            error_get_wx_1: '获取微信用户信息失败，请重新扫码(1)',
            error_get_wx_2: '获取微信用户信息失败，请重新扫码(2)',
            error_no_step_1: '请先输入账号密码',
            error_wx_is_not_you: '当前扫码微信不是账号绑定的微信号',
            error_wx_server_error: '连接微信服务器失败，请稍后重试',
            error_wx_is_binded: '该微信号已被绑定，请更换微信号扫码',
            error_wx_is_notbind: '该用户没有绑定微信',
            error_email_is_notbind: '没有该邮箱绑定的用户',
            error_get_sms_1: '请先验证账号密码',
            error_get_sms_2: '手机验证码错误',
            error_get_sms_3: '该手机号没有和当前账号绑定，请检查确认',
            error_get_sms_4: '当前手机号不是账号绑定的手机号',
        },
        personalErrorText: {
            error_bind_wx_1: '获取微信用户信息失败，请重试(1)',
            error_bind_wx_2: '获取微信用户信息失败，请重试(2)',
            error_bind_wx_3: '获取微信用户信息失败，请重试(3)',
            error_bind_wx_4: '此用户已绑定微信账号，请勿重复绑定',
            error_bind_wx_5: '此微信账号已绑定了平台上的账户，请勿重复绑定。',
            error_bind_wx_6: '请先验证再绑定微信',
            error_get_wx_1: '获取微信用户信息失败，请重新扫码(1)',
            error_get_wx_2: '获取微信用户信息失败，请重新扫码(2)',
            error_wx_server_error: '连接微信服务器失败，请稍后重试',
            error_no_step_1: '请先进行身份验证',
            error_wx_is_not_you: '当前扫码微信不是账号绑定的微信号',
            error_wx_is_binded: '该微信号已被绑定，请更换微信号扫码'
        },
        getRootUrl () {
            if ('laravel' in window) {
                if ('app_url' in window.laravel) {
                    return window.laravel.app_url;
                }
            }
            return '';
        },
        webUrl: {
            loginPage: process.env.NODE_ENV === 'production' ? '/login' : '/login.html',
            personalPage: process.env.NODE_ENV === 'production' ? '/usercenter/personal' : '/personal.html',
            registerPage: process.env.NODE_ENV === 'production' ? '/register' : '/register.html',
            appPage: process.env.NODE_ENV === 'production' ? '/usercenter/index' : '/index.html'
        },
        normal: {
            extCount: 9,
            name: 'ysq'
        },
        apiUrl: {
            captcha: '/vericode/image',
            appUrls: '/urls',
            formLogin: '/usercenter/login',
            checkLogin: '/checklogin',
            oauthAppInfo: '/oauth/app',
            forgetPwd: '/user/password/forget',
            resetPwd: '/user/password/reset',
            inviteCheck: '/useinvite',
            inviteUser: '/site/user/invite/use',
            checkInvite: '/checkinvite',
            wxCreate: '/usercenter/wx/state/normal',
            wxInvite: '/wx/state/invite',
            selfInfo: '/usercenter/self/user/info',
            selfAppList: '/usercenter/self/site/app/list',
            selectSite: '/usercenter/selsite',
            editPwd: '/usercenter/self/user/password/edit',
            bindPhone: '/usercenter/self/user/phone/bind',
            unBindPhone: '/usercenter/self/user/phone/unbind',
            avatar: '/user/avatar/',
            sendPhoneCode: '/vericode/sms',
            bindEmail: '#',
            sendEmailCode: '/vericode/email',
            removeAcc: '/usercenter/self/user/del',
            bindWx: '/wx/bind',
            bindWxCb: '/usercenter/self/user/wx/bind/cb',
            unBindWx: '/usercenter/wx/unbind',
            unBindWxCb: '/usercenter/wx/unbind/cb',
            wxAuth4Passwd: '/usercenter/wx/wxAuth4Passwd',
            validatePhone: '#',
            confirmResetPwd: '/usercenter/self/resetPasswd',
            validateEmail: '#',
            logout: '/usercenter/logout',
            loginWithSms: '/sms/login',
            bindStatus: '/user/bind/status',
            sendCode4ForgetPwd: '/user/password/reset/sms/send',
            forgetPwdUsePhone: '/user/password/reset/sms',
            forgetPwdUseOPwd: '/user/password/edit',
            forgetPwdUseWx: '/user/password/reset/wx',
            forgetPwdScanWx: '/user/password/reset/wx/cb',
            userInfoEdit: '/usercenter/self/user/info/edit',
            favList: '/usercenter/self/siteapp/fav/list',
            addFavApps: '/usercenter/self/siteapp/fav/edit',
            sortFavApps: '/usercenter/self/siteapp/fav/sort',
            authSelf: '/usercenter/self/user/verification',
            authWxCb: '/usercenter/self/verification/wx/cb',
            unbindPhoneWx: '/usercenter/self/user/phone/unbind/wx/cb',
            editEmail: '/usercenter/self/user/email/edit',
            selfNoticeList: '/usercenter/self/user/notice/list',
            selfOtherMessageList: '/usercenter/self/user/othermessage/list',
            selfCmsWait: '/usercenter/self/user/cms/wait',
            verifySceneId: '/api/wx/service/verifySceneId',
            tmpPage: '/wx/service/wxLoginTmpPage',
            wxSubcribeUrl: '/wx/subcribe/url',
            wxSubcribeCheck: '/wx/subcribe/check',
            wxSubcribeLogin: '/wx/subcribe/login',
            wxLogin: '/newmedia/login/guide',
            siteAppList: '/mc/site/app/all',
            orgSelfList: '/usercenter/self/org/list',
            orgAppList:'/usercenter/self/org/app/list',
            orgFavList: '/usercenter/self/app/fav/list',
            orgFavToggle: '/usercenter/self/app/fav/toggle',
            orgFavSort: '/usercenter/self/app/fav/sort',
            hasBind:'/user/bind/status', //短信验证错误跳转回来时调用他，因为这个时候没有调用checkLogin，无法获得绑定状态
        },
        opts: {},
        constance: {
            OLD_LDXX_ID: 21,
            SITE_GDSF_SJDP_ID: 20,
            SITE_SJDP_ID: 13,
            SITE_JDHY_ZJDC_ID: 18,
            SITE_JDHY_ZCJD_ID: 19,
            SITE_GLKH_TCLD_ID: 16,
            SITE_GLKH_TJXT_ID: 17,
            GDSF_ID: 2,
            nickname: '微信',
            email: '邮箱',
            phone: '手机'
        }
    };

    Object.defineProperties(Vue.prototype, {
        $config: {
            get () {
                return config;
            }
        }
    });

    Object.defineProperties(injection, {
        config: {
            get () {
                return config;
            }
        }
    });
}
